var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRedCross({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 14C10.8691 14 14 10.8691 14 7C14 3.13091 10.8691 0 7 0C3.13091 0 0 3.13091 0 7C0 10.8691 3.13091 13.9873 7 14ZM4.74727 5.65091C4.49273 5.39636 4.49273 5.00182 4.74727 4.74727C5.00182 4.49273 5.39636 4.49273 5.65091 4.74727L7 6.09636L8.34909 4.74727C8.60364 4.49273 8.99818 4.49273 9.25273 4.74727C9.50727 5.00182 9.50727 5.39636 9.25273 5.65091L7.90364 7L9.25273 8.34909C9.49454 8.60364 9.49454 8.99818 9.25273 9.25273C9.12545 9.36727 8.96 9.43091 8.79455 9.43091C8.62909 9.43091 8.46364 9.36727 8.34909 9.25273L7 7.90364L5.65091 9.25273C5.53636 9.36727 5.37091 9.43091 5.20545 9.43091C5.04 9.43091 4.87455 9.36727 4.74727 9.25273C4.50545 8.99818 4.50545 8.60364 4.74727 8.34909L6.09636 7L4.74727 5.65091Z",
    fill: "#FF4949"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedCross);
export default __webpack_public_path__ + "static/media/red-cross.1a2a71f542ba0cd8c2b0e7658680f457.svg";
export { ForwardRef as ReactComponent };